/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LicenseStatusDto,
  ProblemDetails,
  TenantLicenseDataDto,
} from '../models/index';
import {
    LicenseStatusDtoFromJSON,
    LicenseStatusDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    TenantLicenseDataDtoFromJSON,
    TenantLicenseDataDtoToJSON,
} from '../models/index';

export interface AddDemoUsageRequest {
    count?: number;
    taskType?: AddDemoUsageTaskTypeEnum;
}

/**
 * 
 */
export class LicensesApi extends runtime.BaseAPI {

    /**
     * Add license usage records
     */
    async addDemoUsageRaw(requestParameters: AddDemoUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }

        if (requestParameters.taskType !== undefined) {
            queryParameters['taskType'] = requestParameters.taskType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/licenses/add-demo-usage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add license usage records
     */
    async addDemoUsage(requestParameters: AddDemoUsageRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.addDemoUsageRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getLicenseDataInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantLicenseDataDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/licenses/license-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TenantLicenseDataDtoFromJSON(jsonValue));
    }

    /**
     */
    async getLicenseDataInfo(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getLicenseDataInfoRaw(initOverrides);
        return this.configuration.handleFunction<TenantLicenseDataDto>(response, errorHandlers);
    }

    /**
     */
    async getLicenseStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseStatusDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/licenses/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseStatusDtoFromJSON(jsonValue));
    }

    /**
     */
    async getLicenseStatus(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getLicenseStatusRaw(initOverrides);
        return this.configuration.handleFunction<LicenseStatusDto>(response, errorHandlers);
    }

    /**
     */
    async pushUsagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/licenses/push-usages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async pushUsages(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.pushUsagesRaw(initOverrides);
        return this.configuration.handleFunction<boolean>(response, errorHandlers);
    }

}

/**
 * @export
 */
export const AddDemoUsageTaskTypeEnum = {
    None: 'None',
    ManualTask: 'ManualTask',
    BeamConstancyCheck: 'BeamConstancyCheck'
} as const;
export type AddDemoUsageTaskTypeEnum = typeof AddDemoUsageTaskTypeEnum[keyof typeof AddDemoUsageTaskTypeEnum];
